<script>
    import { onMount } from "svelte";
    import Select from "svelte-select/Select.svelte";
    import {
        Loader,
    } from "../../../../../Components/Common/index.svelte";

    import { apiMethods } from "../../../../../Services/index.svelte";
    import {
        AustralianStates,
        DirectInsuranceType,
        InsuranceType,
        defaultState,
    } from "../../../../../Utils/utilEnums.svelte";
    import {
        insuranceFund,
        workersCompensation,
        trafficAccidentAuthorities,
        loggedInDoctorDetail,
    } from "../../../../../stores";
    import {
        checkMedicareNoValidation,
        getDvaStringValidation,
        getEmailValidation,
        getPrivateInsuranceFundCoverTypes,
        getPrivateInsuranceFundDefaultCoverType,
        isObjectEmpty,
        privateInsuranceFundHasCoverTypes,
        showError,
        showException,
    } from "../../../../../Utils/utilFunctions.svelte";
    import {
        cacheInsuranceFunds,
        cacheTrafficAccidentAuthorities,
        cacheWorkersCompensation,
    } from "../../../../../Utils/utilCache.svelte";
    import {
        addErrorInput,
        removeErrorInput,
    } from "../../../helpers/encounterUtils.svelte";
    import {
        hideMedicareInsurance,
        noNeedForMedicareNoArr,
        unknownPatientInsuranceType,
    } from "../../../../../Utils/utilConstants.svelte";
    import OpvStatusModal from "../../OpvStatusModal.svelte";
    export let patientDetails = {},
        index,
        patientEncounterDetails = {},
        insuranceDetails = {},
        overrideValidation,
        workerCompensation,
        workerCompensationObj = {},
        trafficAuthority,
        trafficAuthorityObj = {},
        publicInPrivateObj = {},
        thirdPartyPayerObj = {},
        defenceObj = {},
        selectedHospital = {},
        commonDetails = {},
        selectedDoctorProvider = {};


    $: if (patientDetails.insuranceType == 0) loadInsuranceFund();

    $: if (patientDetails.insuranceType == 16) loadWorkerCompensation();

    $: if (patientDetails.insuranceType == 16 && $workersCompensation.length)
        _syncDisplayOptionsByState();

    $: if (patientDetails.insuranceType == 17) loadTrafficAuthorities();

    $: if (
        patientDetails.insuranceType == 17 &&
        $trafficAccidentAuthorities.length
    )
        _syncDisplayOptionsByState();

    $: if (
        patientDetails.insuranceType == DirectInsuranceType.ThirdPartyInsurer && !hasFetchedThirdPartyInsurers &&
        commonDetails?.selectedDoctor?.id
    )
        loadThirdPartyInsurers();
   

    $: showCoverTypeForPrivateInsurance =
        patientDetails.insuranceType == 0 &&
        insuranceDetails?.insuranceFund?.id &&
        privateInsuranceFundHasCoverTypes(insuranceDetails.insuranceFund.id);

    $: isValidMedicareNo =
        hideMedicareInsurance.includes(Number(patientDetails.insuranceType)) ||
        Number(patientDetails.insuranceType) == unknownPatientInsuranceType
            ? true
            : patientDetails.medicareNo
              ? checkMedicareNoValidation(patientDetails.medicareNo)
              : noNeedForMedicareNoArr.includes(
                    Number(patientDetails.insuranceType),
                );

    $: isValidInsurerEmail = workerCompensationObj.insurerEmail
          ? getEmailValidation(workerCompensationObj.insurerEmail)
          : true;

    $: isValidTrafficAuthorityEmail = trafficAuthorityObj.email
          ? getEmailValidation(trafficAuthorityObj.email)
          : true;

    $: isValidEmployerEmail = insuranceDetails.employerEmail
          ? getEmailValidation(insuranceDetails.employerEmail)
          : true;

    $: isValidPipEmail = publicInPrivateObj.email
          ? getEmailValidation(publicInPrivateObj.email)
          : true;

    $: isValidThirdPartyPayerEmail = thirdPartyPayerObj.email
          ? getEmailValidation(thirdPartyPayerObj.email)
          : true;

    $: isValidThirdPartyPayerPhone = thirdPartyPayerObj.phone
          ? thirdPartyPayerObj.phone.length >= 6
          : true;

    $: isValidDvaNumber =
        patientDetails.insuranceType != 20
            ? true
            : getDvaStringValidation(patientDetails.veteranNo);

    $: showOpvCheckBtn = _ToggleOpvCheckBtnVisibility(
        patientDetails,
        insuranceDetails
    );

    let hasInsuranceFundFetched = false,
        isLoadingInsuranceFund = false;

    let hasWorkerCompensationFetched = false,
        isLoadingWorkerCompensation = false,
        workerCompensationOptions = [];

    let hasTrafficAuthoritiesFetched = false,
        isLoadingTrafficAuthorities = false,
        trafficAuthorityOptions = [];

    let doctorDefaultPrivateInsuranceFundCoverTypes = [],
        hasDefaultPrivateInsuranceFundCoverTypesFetched = false;

    let errInputs = [];

    const defaultOverseasFund = {
                                    id: 0,
                                    name: "Other Overseas Insurance"
                                };

    let isCheckingOPV = false,
        opvResultModalOpen = false,
        opvResult = {};

    let skipWorkCoverClaimNo = false,
        skipTrafficAuthorityClaimNo = false,
        skipDefenceClaimNo = false;

    let isLoadingThirdPartyInsurers = false,
        thirdPartyInsurers = [],
        hasFetchedThirdPartyInsurers = false;

    const skipWcAndTacText = "I don't have the claim ID.";
    const skipDefenceText = "I don't have the PID and/or DAN.";

    onMount(() => {
        if (patientDetails.insuranceType == 16) _syncWorkCompensation();
        else if (patientDetails.insuranceType == 17) _syncTrafficAuthorities();
    });

    export const checkValidation = () => {
        errInputs = [];

        _updateInvalidFieldsStyle();

        return errInputs;
    };

    export const onDoctorChange = async () => {
        if( patientDetails.insuranceType == DirectInsuranceType.ThirdPartyInsurer) {
            hasFetchedThirdPartyInsurers = false;
            thirdPartyPayerObj = {}; //remove already selected insurer
            await loadThirdPartyInsurers();
        }
    }

    export const loadInsuranceFund = async () => {
        if (!$insuranceFund.length && !hasInsuranceFundFetched) {
            hasInsuranceFundFetched = true;

            isLoadingInsuranceFund = true;

            await cacheInsuranceFunds();

            isLoadingInsuranceFund = false;
        }

        if (patientDetails.insuranceId) _syncInsuranceFund();

        if (
            !doctorDefaultPrivateInsuranceFundCoverTypes.length &&
            !hasDefaultPrivateInsuranceFundCoverTypesFetched &&
            $loggedInDoctorDetail.id
        ) {
            hasDefaultPrivateInsuranceFundCoverTypesFetched = true;

            await apiMethods.getMethod
                .getAccountInsuranceDefaultCover($loggedInDoctorDetail.id)
                .then((res) => {
                    if (!res || res.error)
                        showError(
                            res.error ??
                                "Failed to load doctor's default insurance fund cover types, please refresh the page and try again and contact support if the issue persists.",
                        );
                    else doctorDefaultPrivateInsuranceFundCoverTypes = [...res];
                });
        }

    };

    export const loadWorkerCompensation = async (syncData = true) => {
        if (!$workersCompensation.length && !hasWorkerCompensationFetched) {
            hasWorkerCompensationFetched = true;

            isLoadingWorkerCompensation = true;

            await cacheWorkersCompensation();

            isLoadingWorkerCompensation = false;
        }

        syncData && _syncWorkCompensation();

        _syncDisplayOptionsByState();

    };

    export const loadTrafficAuthorities = async (syncData = true) => {
        if (
            !$trafficAccidentAuthorities.length &&
            !hasTrafficAuthoritiesFetched
        ) {
            hasTrafficAuthoritiesFetched = true;

            isLoadingTrafficAuthorities = true;

            await cacheTrafficAccidentAuthorities();

            isLoadingTrafficAuthorities = false;
        }

        syncData && _syncTrafficAuthorities();

        _syncDisplayOptionsByState();

    };

    const loadThirdPartyInsurers = async () => {
        if (isLoadingThirdPartyInsurers) return;

        isLoadingThirdPartyInsurers = true;

        await apiMethods.getMethod
            .getThirdPartyInsurers(0, 999999, {
                "filter[doctorId]": commonDetails.selectedDoctor.id,
            })
            .then((res) => {
                if (!res || res.error)
                    showError(
                        res.error ??
                            "Failed to load third party insurers, please refresh the page and try again and contact support if the issue persists.",
                    );
                else {
                    thirdPartyInsurers = [...res.results];
                    hasFetchedThirdPartyInsurers = true;
                }
            });

        await loadThirdPartyInsurerSuggestions();

        isLoadingThirdPartyInsurers = false;
    };

    const loadThirdPartyInsurerSuggestions = async () =>
        await apiMethods.getMethod
            .getThirdPartyInsurerSuggestions(commonDetails.selectedDoctor.id)
            .then((res) => {
                if (!res || res.error)
                    showError(
                        res.error ??
                            "Failed to load third party insurer suggestions, please refresh the page and try again and contact support if the issue persists.",
                    );
                else {
                    const suggestedInsurers = res.results;

                    if (!suggestedInsurers.length) return;

                    const result = [];

                    const suggestedInsurerIds = [];
                    const len = Math.min(suggestedInsurers.length, 5);

                    for (let i = 0; i < len; i++) {
                        const insurer = suggestedInsurers[i];

                        result.push({
                            ...insurer,
                            groupName: "Suggested Insurers",
                        });

                        suggestedInsurerIds.push(insurer.id);
                    }

                    thirdPartyInsurers.map((insurer) => {
                        if (!suggestedInsurerIds.includes(insurer.id))
                            result.push({
                                ...insurer,
                                groupName: "Other Insurers",
                            });
                    });

                    thirdPartyInsurers = [...result];
                }
    });

    const clearCurrentInsuranceFund = () => {
        insuranceDetails.insuranceFund = null;

        if (insuranceDetails.privateCoverType)
            delete insuranceDetails.privateCoverType;

        const insuranceFundContainer = document.getElementById(
            `insuranceFundContainer-${index}`,
        );
        const insuranceFundSelect = document.getElementById(
            `insuranceFundSelect-${index}`,
        );
        insuranceFundContainer.style.outline = "";
        insuranceFundSelect.placeholder = "Insurance fund";
    };

    const handleSelectInsuranceFund = () => {
        
        if (
            insuranceDetails.insuranceFund &&
            doctorDefaultPrivateInsuranceFundCoverTypes.some(
                (type) => type.insuranceId == insuranceDetails.insuranceFund.id,
            )
        ) {
            insuranceDetails.privateCoverType =
                doctorDefaultPrivateInsuranceFundCoverTypes.find(
                    (type) =>
                        type.insuranceId == insuranceDetails.insuranceFund.id,
                ).insurance;
        } else
            insuranceDetails.privateCoverType =
                getPrivateInsuranceFundDefaultCoverType(
                    insuranceDetails.insuranceFund.id,
                );

        const insuranceFundContainer = document.getElementById(
            `insuranceFundContainer-${index}`,
        );
        const insuranceFundSelect = document.getElementById(
            `insuranceFundSelect-${index}`,
        );
        insuranceFundContainer.style.outline = "";
        insuranceFundSelect.placeholder = "";
    };

    const clearWorkerCompensation = () => {
        workerCompensation = null;

        const workerCompensationContainer = document.getElementById(
            `workerCompensationContainer-${index}`,
        );
        const workerCompensationSelect = document.getElementById(
            `workerCompensationSelect-${index}`,
        );

        if (workerCompensationContainer)
            workerCompensationContainer.style.outline = "";
        if (workerCompensationSelect)
            workerCompensationSelect.placeholder =
                "Workcover insurer (if known)";
    };

    const updateWorkcoverInsurerEmail = () =>
        (workerCompensationObj.insurerEmail = workerCompensation.email);

    const clearTrafficAuthority = () => {
        trafficAuthority = null;

        const trafficAuthoritiesContainer = document.getElementById(
            `trafficAuthoritiesContainer-${index}`,
        );

        const trafficAuthoritySelect = document.getElementById(
            `trafficAuthoritySelect-${index}`,
        );

        if (trafficAuthoritiesContainer)
            trafficAuthoritiesContainer.style.outline = "";
        if (trafficAuthoritySelect)
            trafficAuthoritySelect.placeholder = "Traffic Accident Authority";
    };

    const updateTrafficAuthorityEmail = () =>
        (trafficAuthorityObj.email = trafficAuthority.email);

    const runOpvCheck = async () => {
        if (isCheckingOPV) return;

        isCheckingOPV = true;

        if (patientDetails.insuranceType == 0)
            patientDetails = {
                ...patientDetails,
                insuranceId: insuranceDetails.insuranceFund.id,
                membershipNo: insuranceDetails.membershipNo,
                membershipRefNo: insuranceDetails.membershipRefNo,
            };

        if (patientDetails.medicareRefNo)
            patientDetails.medicareRefNo = Number(patientDetails.medicareRefNo);

        patientDetails.title =
            patientDetails.title.toString().toLowerCase() == "title"
                ? 20
                : patientDetails.title;

        await apiMethods.postMethod
            .checkOPV(patientDetails, true)
            .then((res) => {
                // if (!res || res.error)
                //     showError(
                //         res.error ??
                //             "Failed opv check process, please refresh the page and try again and contact support if the issue persists.",
                //     );
                // else _openOpvResultModal(res);
                _openOpvResultModal(res);
            })
            .catch((err) => showException(err));

        isCheckingOPV = false;
    };

    const handleSkipWorkCoverClaimNo = () => {
        if (skipWorkCoverClaimNo) {
            const workerCompensationClaimNumberInput = document.getElementById(
                `workerCompensationClaimNumberInput-${index}`,
            );
            workerCompensationClaimNumberInput.style.outline = "";
            workerCompensationClaimNumberInput.placeholder =
                "Worker compensation claim number";
        }
    };

    const handleSkipTacClaimNo = () => {
        if (skipTrafficAuthorityClaimNo) {
            const trafficAuthorityClaimNumberInput = document.getElementById(
                `trafficAuthorityClaimNumberInput-${index}`,
            );
            trafficAuthorityClaimNumberInput.style.outline = "";
            trafficAuthorityClaimNumberInput.placeholder =
                "Traffic Accident Authority claim number";

            const trafficAuthoritiesContainer = document.getElementById(
                `trafficAuthoritiesContainer-${index}`,
            );
            if (trafficAuthoritiesContainer)
                trafficAuthoritiesContainer.style.outline = "";
        }
    };

    const handleSkipDefenceClaimNo = () => {
        if (skipDefenceClaimNo) {
            const insuranceDetailsPIDField = document.getElementById(
                `insuranceDetailsPIDField-${index}`,
            );
            insuranceDetailsPIDField.style.outline = "";
            insuranceDetailsPIDField.placeholder = "PID";

            const insuranceDetailsDANField = document.getElementById(
                `insuranceDetailsDANField-${index}`,
            );
            insuranceDetailsDANField.style.outline = "";
            insuranceDetailsDANField.placeholder = "DAN";
        }
    };

    const groupBy = (option) => option.groupName;

    // HELPER FUNCTIONS
    const _ToggleOpvCheckBtnVisibility = (
        pDetails = {},
        iDetails = {}
    ) => {

        const { insuranceType, medicareNo, firstName, birthDate } = pDetails;

        if (
            insuranceType == "Insurance Type" ||
            insuranceType == unknownPatientInsuranceType ||
            !firstName ||
            !birthDate
        )
            return false;

        const allowOpvCheckInsuranceTypes = [0, 11, 20];

        if (!allowOpvCheckInsuranceTypes.includes(insuranceType)) return false;

        switch (insuranceType) {
            case 0:
                const { insuranceFund } = iDetails;
                return isValidMedicareNo && insuranceFund && insuranceFund.id;
            case 11:
                return isValidMedicareNo;
            case 20:
                return (medicareNo && isValidMedicareNo) || isValidDvaNumber;
            default:
                return false;
        }
    };

    const _updateInvalidFieldsStyle = () => {

        const patientInsuranceTypeSelect = document.getElementById(
            `patientInsuranceTypeSelect-${index}`,
        );
        if (patientInsuranceTypeSelect.value == "Insurance Type")
            errInputs = addErrorInput(`patientInsuranceTypeSelect-${index}`, errInputs);
        else if (patientInsuranceTypeSelect.value == "Insurance Type")
            patientDetails.insuranceType = unknownPatientInsuranceType;
        else {
            const { medicareRefNo } = patientDetails;

            const insuranceType = patientInsuranceTypeSelect.value;

            if (insuranceType != 15 && Number(insuranceType) != unknownPatientInsuranceType) {
                if (!isValidMedicareNo && !overrideValidation)
                    errInputs = addErrorInput(
                        `patientMedicareNoField-${index}`,
                        errInputs,
                        "Medicare No.",
                    );
                else if ((insuranceType != 10 && InsuranceType != 18) || overrideValidation)
                    errInputs = removeErrorInput(
                        `patientMedicareNoField-${index}`,
                        errInputs,
                        "Medicare No.",
                    );

                if (
                    !medicareRefNo &&
                    !noNeedForMedicareNoArr.includes(Number(insuranceType)) &&
                    !overrideValidation
                )
                    errInputs = addErrorInput(
                        `patientMedicareRefNoField-${index}`,
                        errInputs,
                        "Medicare Ref No.",
                    );
                else
                    errInputs = removeErrorInput(
                        `patientMedicareRefNoField-${index}`,
                        errInputs,
                        "Medicare Ref No.",
                    );

                if ((insuranceType == 0 || insuranceType == 10) && !overrideValidation) {
                     if ((insuranceType == 0 && !insuranceDetails.insuranceFund?.id) || (insuranceType == 10 && !insuranceDetails.insuranceFund))
                        errInputs = addErrorInput(
                            `insuranceFundContainer-${index}`,
                            errInputs,
                            "Insurance fund",
                        );
                    if ((insuranceType == 0 && !insuranceDetails.membershipNo) || (insuranceType == 10 && insuranceDetails.insuranceFund?.id != 0 && !insuranceDetails.membershipNo))
                        errInputs = addErrorInput(
                            `insuranceDetailsMembershipNoField-${index}`,
                            errInputs,
                            "Membership No",
                        );
                } else {
                    errInputs = removeErrorInput(
                            `insuranceFundContainer-${index}`,
                            errInputs,
                            "Insurance fund",
                        );
                    errInputs = removeErrorInput(
                            `insuranceDetailsMembershipNoField-${index}`,
                            errInputs,
                            "Membership No",
                        );
                }

                if (insuranceType == 16) _checkWorkersCompValue();

                if (insuranceType == 17) _checkTrafficAuthorityValue();

                if (insuranceType == 18 && !overrideValidation) {
                    if (!thirdPartyPayerObj.name)
                        errInputs = addErrorInput(
                            `thirdPartyPayerNameInput-${index}`,
                            errInputs,
                            "Payer name",
                        );

                    if (!thirdPartyPayerObj.address && !thirdPartyPayerObj.email) {
                        errInputs = addErrorInput(
                            `thirdPartyPayerAddressInput-${index}`,
                            errInputs,
                            "",
                        );
                        errInputs = addErrorInput(
                            `thirdPartyPayerEmailInput-${index}`,
                            errInputs,
                            "",
                        );
                    } else {
                        errInputs = removeErrorInput(`thirdPartyPayerAddressInput-${index}`, errInputs);
                        errInputs = removeErrorInput(`thirdPartyPayerEmailInput-${index}`, errInputs);
                    }
                } else {
                    errInputs = removeErrorInput(
                            `thirdPartyPayerNameInput-${index}`,
                            errInputs,
                            "Payer name",
                        );
                    errInputs = removeErrorInput(`thirdPartyPayerAddressInput-${index}`, errInputs);
                    errInputs = removeErrorInput(`thirdPartyPayerEmailInput-${index}`, errInputs);
                }

                if (insuranceType == 20 && !isValidDvaNumber && !overrideValidation) {
                    errInputs = addErrorInput(
                        `insuranceDetailsDVANumberField-${index}`,
                        errInputs,
                        "Veteran number",
                    );
                } else {
                     errInputs = removeErrorInput(
                        `insuranceDetailsDVANumberField-${index}`,
                        errInputs,
                        "Veteran number",
                    );
                }

                if (
                    (insuranceType == 25 || insuranceType == 26) &&
                    !overrideValidation &&
                    !skipDefenceClaimNo
                ) {
                    if (!defenceObj.pid)
                        errInputs = addErrorInput(
                            `insuranceDetailsPIDField-${index}`,
                            errInputs,
                            "PID",
                        );
                    if (!defenceObj.dan)
                        errInputs = addErrorInput(
                            `insuranceDetailsDANField-${index}`,
                            errInputs,
                            "DAN",
                        );
                } else {
                     errInputs = removeErrorInput(
                            `insuranceDetailsPIDField-${index}`,
                            errInputs,
                            "PID",
                        );
                     errInputs = removeErrorInput(
                            `insuranceDetailsDANField-${index}`,
                            errInputs,
                            "DAN",
                        );
                }

                if (
                    insuranceType == 30 &&
                    publicInPrivateObj.email &&
                    !isValidPipEmail
                ) {
                    errInputs = addErrorInput(
                        `pipEmailInput-${index}`,
                        errInputs,
                        "Email to send invoice",
                    );
                }
            } else if (!isValidMedicareNo)
                errInputs = addErrorInput(
                    `patientMedicareNoField-${index}`,
                    errInputs,
                    "Medicare No.",
                );
        }
    }; 

    const _checkWorkersCompValue = () => {
      
        const pairOneMissing =
            !overrideValidation &&
            (!workerCompensation?.id ||
                (workerCompensation.id &&
                    !skipWorkCoverClaimNo &&
                    !workerCompensationObj.claimNumber) ||
                !isValidInsurerEmail);

        const pairTwoMissing =
            !overrideValidation &&
            (!insuranceDetails.employer ||
                !insuranceDetails.employerEmail ||
                (insuranceDetails.employerEmail && !isValidEmployerEmail));

        if (
            (pairOneMissing && !pairTwoMissing) ||
            (!pairOneMissing && pairTwoMissing) || overrideValidation
        ) {
            const workerCompensationContainer = document.getElementById(
                `workerCompensationContainer-${index}`,
            );
            workerCompensationContainer.style.outline = "";
            workerCompensationContainer.style.borderRadius = "5px";

            errInputs = removeErrorInput(
                `workerCompensationInsurerEmailInput-${index}`,
                errInputs,
                "Workcover insurer email",
            );
            errInputs = removeErrorInput(
                `workerCompensationClaimNumberInput-${index}`,
                errInputs,
                "Worker compensation claim number",
            );
            errInputs = removeErrorInput(
                `insuranceDetailsEmployerField-${index}`,
                errInputs,
                "Employer",
            );
            errInputs = removeErrorInput(
                `insuranceDetailsEmployerEmailField-${index}`,
                errInputs,
                "Employer email",
            );
        } else if (pairOneMissing && pairTwoMissing) {
            const workerCompensationContainer = document.getElementById(
                `workerCompensationContainer-${index}`,
            );
            workerCompensationContainer.style.outline = "red solid 2px";
            workerCompensationContainer.style.borderRadius = "5px";

            if (!skipWorkCoverClaimNo)
                errInputs = addErrorInput(
                    `workerCompensationClaimNumberInput-${index}`,
                    errInputs,
                    "Worker compensation claim number",
                );
            errInputs = addErrorInput(
                `insuranceDetailsEmployerField-${index}`,
                errInputs,
                "Employer",
            );
            errInputs = addErrorInput(
                `insuranceDetailsEmployerEmailField-${index}`,
                errInputs,
                "Employer email",
            );
        }

        if (!isValidInsurerEmail)
            errInputs = addErrorInput(
                `workerCompensationInsurerEmailInput-${index}`,
                errInputs,
            );

        if (!isValidEmployerEmail)
            errInputs = addErrorInput(
                `insuranceDetailsEmployerEmailField-${index}`,
                errInputs,
            );
    };

    const _checkTrafficAuthorityValue = () => {
        if (
            !overrideValidation &&
            !trafficAuthority?.id &&
            !skipTrafficAuthorityClaimNo
        ) {
            const trafficAuthoritiesContainer = document.getElementById(
                `trafficAuthoritiesContainer-${index}`,
            );
            trafficAuthoritiesContainer.style.outline = "red solid 2px";
            trafficAuthoritiesContainer.style.borderRadius = "5px";
            errInputs = addErrorInput(`trafficAuthoritiesContainer-${index}`, errInputs);
        } else {
            const trafficAuthoritiesContainer = document.getElementById(
                `trafficAuthoritiesContainer-${index}`,
            );
            trafficAuthoritiesContainer.style.outline = "";
            trafficAuthoritiesContainer.style.borderRadius = "5px";
            errInputs = removeErrorInput(`trafficAuthoritiesContainer-${index}`, errInputs);
        }

        if (
            trafficAuthority?.id &&
            !isValidTrafficAuthorityEmail &&
            !overrideValidation
        )
            errInputs = addErrorInput(
                `trafficAuthorityEmailInput-${index}`,
                errInputs,
                "Traffic Accident Authority email",
            );
        else {
            errInputs = removeErrorInput(
                `trafficAuthorityEmailInput-${index}`,
                errInputs,
                "Traffic Accident Authority email",
            );
        }

        if (
            !trafficAuthorityObj.claimNumber &&
            !overrideValidation &&
            !skipTrafficAuthorityClaimNo
        )
            errInputs = addErrorInput(
                `trafficAuthorityClaimNumberInput-${index}`,
                errInputs,
                "Claim number",
            );
        else {
            errInputs = removeErrorInput(
                `trafficAuthorityClaimNumberInput-${index}`,
                errInputs,
                "Claim number",
            );
        }
    };

    export const _syncInsuranceFund = () => {
        insuranceDetails.insuranceFund = $insuranceFund.find(
            (fund) => fund.id == patientDetails.insuranceId,
        );
        insuranceDetails.membershipNo = patientDetails.membershipNo;
        insuranceDetails.membershipRefNo = patientDetails.membershipRefNo;

        insuranceDetails.privateCoverType = patientDetails.insurance;

    };

    const _syncWorkCompensation = () => {
        if (
            $workersCompensation.length &&
            !workerCompensation?.id &&
            patientEncounterDetails.patientEncounterWorkCoverData
                ?.workCoverAuthority
        )
            workerCompensation = $workersCompensation.find(
                (compensation) =>
                    compensation.id ==
                    patientEncounterDetails.patientEncounterWorkCoverData
                        .workCoverAuthority,
            );
    };

    const _syncDisplayOptionsByState = () => {
        const { insuranceType, insuranceState } = patientDetails;

        if(insuranceType == 10) {
            //was changed to overseas, remove preselect the default overseas insurance fund
            insuranceDetails.insuranceFund = defaultOverseasFund;
        }
        if (insuranceType == 16) {
            if (!$workersCompensation.length || !insuranceState) return;

            workerCompensationOptions = $workersCompensation.filter(
                ({ state }) =>
                    state.toLowerCase() == insuranceState.toLowerCase(),
            );

            if (
                workerCompensation &&
                workerCompensation.state?.toLowerCase() !=
                    insuranceState.toLowerCase()
            )
                clearWorkerCompensation();

            if (workerCompensationOptions.length == 1) {
                workerCompensation = workerCompensationOptions[0];
                updateWorkcoverInsurerEmail();
            }
        } else if (insuranceType == 17) {
            if (!$trafficAccidentAuthorities.length || !insuranceState) return;

            trafficAuthorityOptions = $trafficAccidentAuthorities.filter(
                ({ state }) =>
                    state.toLowerCase() == insuranceState.toLowerCase(),
            );

            if (
                trafficAuthority &&
                trafficAuthority.state?.toLowerCase() !=
                    insuranceState.toLowerCase()
            )
                clearTrafficAuthority();

            if (trafficAuthorityOptions.length == 1) {
                trafficAuthority = trafficAuthorityOptions[0];
                updateTrafficAuthorityEmail();
            }
        } else if (insuranceType == 30) _syncPipInsuranceData();
    };

    export const _syncPipInsuranceData = () => {
        if (!selectedHospital || !selectedHospital.details || isObjectEmpty(selectedHospital)) {
            publicInPrivateObj.email = "";
            publicInPrivateObj.vendorNumbers = "";
            return;
        }

        publicInPrivateObj.email = selectedHospital?.details?.email ?? "";

        const { email, id } = selectedHospital.details;

        publicInPrivateObj.email = email;

        const providerHospitals = selectedDoctorProvider.hospitals;

        if (!providerHospitals?.length) {
            publicInPrivateObj.vendorNumbers = "";
            return;
        }

        const targetHospital = providerHospitals.find(
            (hospital) => hospital.hospitalId == id,
        );

        if (!targetHospital) {
            publicInPrivateObj.vendorNumbers = "";
            return;
        }

        publicInPrivateObj.vendorNumbers = targetHospital.pipVendorNumber;
    };

    const _handleSelectThirdPartyInsurer = (e) => {
        const selectedInsurerId = e.detail.id;

        const selectedInsurer = thirdPartyInsurers.find(
            (insurer) => insurer.id == selectedInsurerId,
        );

        if (!selectedInsurer || isObjectEmpty(selectedInsurer)) return;

        const { name, email, phone, address, addGST } = selectedInsurer;

        thirdPartyPayerObj.name = name;
        thirdPartyPayerObj.email = email;
        thirdPartyPayerObj.phone = phone;
        thirdPartyPayerObj.address = address;
        thirdPartyPayerObj.addGST = addGST;
    };

    const _syncTrafficAuthorities = () => {
        if (
            $trafficAccidentAuthorities.length &&
            !trafficAuthority?.id &&
            patientEncounterDetails.patientEncounterTrafficAccidentData
                ?.trafficAccidentAuthority
        )
            trafficAuthority = $trafficAccidentAuthorities.find(
                (authority) =>
                    authority.id ==
                    patientEncounterDetails.patientEncounterTrafficAccidentData
                        .trafficAccidentAuthority,
            );

        if (trafficAuthority?.id)
            trafficAuthorityObj.email = trafficAuthority.email;
    };

    const _openOpvResultModal = (res = {}) => {
        opvResult = { ...res, insuranceType: patientDetails.insuranceType };
        opvResultModalOpen = true;
    };

    const _closeOpvResultModal = () => {
        opvResult = {};
        opvResultModalOpen = false;
    };
    
</script>

<div class="flex flex-col flex-1 p-4 w-full gap-4" id="insuranceDetailsContainer">
    <div class="flex flex-row gap-2">
        <!-- insurance type -->
        <div class={`flex-1 flex gap-2 items-center`}>
            <p class="title">Insurance type:</p>
            <select
                class="select select-bordered select-sm w-remaining"
                id={`patientInsuranceTypeSelect-${index}`}
                bind:value={patientDetails.insuranceType}
                on:focus={({ target }) => (target.style.outline = "")}
                on:change={_syncDisplayOptionsByState}
            >
                <option disabled>Insurance Type</option>
                {#each InsuranceType.sort((a, b) => a.order - b.order).filter((insurance) => insurance.id != 26) as insurance}
                    {#if insurance.id != 25 && insurance.id != 26}
                        <option
                            value={insurance.id}
                            selected={insurance.id ==
                                patientDetails.insuranceType}
                        >
                            {insurance.type}
                        </option>
                    {:else if patientDetails.insuranceType == 25}
                        <option value={Number(25)} selected>
                            Australian Defence Force
                        </option>
                    {:else if patientDetails.insuranceType == 26}
                        <option value={Number(26)} selected>
                            Australian Defence Force
                        </option>
                    {:else}
                        <option value={Number(25)}>
                            Australian Defence Force
                        </option>
                    {/if}
                {/each}

                {#if patientDetails.insuranceType == unknownPatientInsuranceType}
                    <option
                        value={unknownPatientInsuranceType}
                        selected
                        disabled
                    >
                        Unknown
                    </option>
                {/if}
            </select>
        </div>
       
        <div class={`flex-1 flex items-center`}>
            {#if patientDetails.insuranceType == 16 || patientDetails.insuranceType == 17}
                <p class="title">Insurance State:</p>    
                <select
                    class="select select-bordered select-sm w-remaining"
                    bind:value={patientDetails.insuranceState}
                    on:change={_syncDisplayOptionsByState}
                >
                    <option disabled>State</option>
                    {#each AustralianStates as state}
                        <option value={state.key}>{state.name}</option>
                    {/each}
                </select>
            {:else if patientDetails.insuranceType == 18}
                <p class="title">Select Insurer:</p>
                {#if isLoadingThirdPartyInsurers}
                    <div class="flex items-center gap-x-2 w-remaining">
                        <Loader />
                        <p>Loading third-party insurers...</p>
                    </div>
                {:else}
                    <Select
                        class="flex flex-1 max-h-[35px] rounded-full w-remaining"
                        items={thirdPartyInsurers}
                        itemId="id"
                        label="name"
                        {groupBy}
                        noOptionsMessage="No Insurer Found"
                        placeholder="Insurer"
                        on:select={_handleSelectThirdPartyInsurer}
                        --placeholder-color="#9CA3AF"
                        --height="32px"
                        --value-container-padding="0"
                        --padding="0 0 0 12px"
                        --font-size="14px"
                    />
                {/if}
            {/if}
        </div>
      
    </div>

    <!-- medicare No., medicare Ref No. -->
    {#if patientDetails.insuranceType !== 10 && patientDetails.insuranceType != 18 && patientDetails.insuranceType !== unknownPatientInsuranceType}
        <div class="flex flex-row gap-2">
            <div class="flex-1 flex items-center">
                <p class="title">Medicare No.:</p>
                <input
                    type="text"
                    id={`patientMedicareNoField-${index}`}
                    placeholder="Medicare No."
                    class="input input-sm input-bordered flex-1 w-remianing"
                    autocomplete="off"
                    bind:value={patientDetails.medicareNo}
                    on:focus={({ target }) => {
                        target.style.outline = "";
                        target.placeholder = "Medicare No.";
                    }}
                    on:input={({ target }) => {
                        patientDetails.medicareNo = target.value
                            .replaceAll(" ", "")
                            .replaceAll("-", "");
                    }}
                />
            </div>

            <div class="flex-1 flex items-center">
                <p class="title">Medicare Ref No.:</p>
                <input
                    type="text"
                    id={`patientMedicareRefNoField-${index}`}
                    placeholder="Medicare Ref No."
                    class="input input-sm input-bordered flex-1 w-remaining"
                    autocomplete="off"
                    bind:value={patientDetails.medicareRefNo}
                    on:focus={({ target }) => {
                        target.style.outline = "";
                        target.placeholder = "Medicare Ref No.";
                    }}
                />
            </div>

            {#if showOpvCheckBtn}
                <div class="flex flex-row gap-x-2 items-center">
                    <p
                        class={`underline ${
                            isCheckingOPV
                                ? "cursor-not-allowed"
                                : "cursor-pointer"
                        }`}
                        on:click|preventDefault={runOpvCheck}
                    >
                        {isCheckingOPV ? "Checking" : "Run OPV Check"}
                    </p>
                    {#if isCheckingOPV}
                        <Loader />
                    {/if}
                </div>
            {/if}
        </div>
    {/if}

    {#if patientDetails.insuranceType == 0 || patientDetails.insuranceType == 10}
        <div class="flex flex-row gap-2">
            <div class={`flex-1 flex items-center`}>
                <p class="title text-left">Fund:</p>
                <div class="flex flex-1 w-remaining rounded-md" id={`insuranceFundContainer-${index}`}>
                    {#if isLoadingInsuranceFund}
                        <div class="flex gap-x-2">
                            <p>Loading Insurance Fund</p>
                            <Loader />
                        </div>
                    {:else}
                        <Select
                            bind:value={insuranceDetails.insuranceFund}
                            id={`insuranceFundSelect-${index}`}
                            class="flex flex-1 max-h-[35px] rounded-full"
                             items={patientDetails.insuranceType == 10 ? 
                                    [   defaultOverseasFund,
                                        ...$insuranceFund.filter((i) => i.isOverseas)] : 
                                    $insuranceFund}
                            itemId="id"
                            label="name"
                            on:clear={clearCurrentInsuranceFund}
                            on:select={handleSelectInsuranceFund}
                            noOptionsMessage="No insurance found"
                            placeholder="Insurance fund"
                            --placeholder-color="#9CA3AF"
                            --height="32px"
                            --value-container-padding="0"
                            --padding="0 0 0 12px"
                            --font-size="14px"
                        />
                    {/if}
                </div>
            </div>
            {#if patientDetails.insuranceType == 10 && insuranceDetails.insuranceFund?.id == 0}
                <div class="flex-1 flex items-center">
                    <p class="title">Fund details:</p>
                    <input
                        type="text"
                        id={`insuranceDetailsOverseasCoverField-${index}`}
                        placeholder="Insurance details"
                        class="input input-sm input-bordered w-remaining"
                        autocomplete="off"
                        bind:value={insuranceDetails.overseasCover}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                            target.placeholder = "Insurance details";
                        }}
                    />
                </div>
            {/if}

            <!-- cover type -->
            {#if patientDetails.insuranceType == 0}
                <div class={`flex-1 flex gap-2 items-center`}>
                    {#if showCoverTypeForPrivateInsurance}
                        <p class="title">Cover Type:</p>
                        <select
                            class="select select-bordered select-sm flex w-remaining"
                            id={`insuranceAmaCoverTypeField-${index}`}
                            bind:value={insuranceDetails.privateCoverType}
                        >
                            {#each getPrivateInsuranceFundCoverTypes(insuranceDetails.insuranceFund.id) as { value, displayName, isDefault }, index}
                                <option
                                    {value}
                                    selected={insuranceDetails.privateCoverType ==
                                        value ||
                                        (!insuranceDetails.privateCoverType &&
                                            (isDefault || index == 0))}
                                >
                                    {displayName}
                                </option>
                            {/each}
                        </select>
                    {/if}
                </div>
            {/if}
          
        </div>
    {/if}

    {#if [0, 10, 16, 17, 18, 20, 25, 26, 30].includes(patientDetails.insuranceType)}
        <div class="flex flex-row gap-2">
            {#if patientDetails.insuranceType == 0 || (patientDetails.insuranceType == 10 && insuranceDetails.insuranceFund?.id > 0)}
                <div class="flex-1 flex items-center">
                    <p class="title">Membership No.:</p>
                    <input
                        type="text"
                        id={`insuranceDetailsMembershipNoField-${index}`}
                        placeholder="Membership No"
                        class="input input-sm input-bordered w-remaining"
                        autocomplete="off"
                        bind:value={insuranceDetails.membershipNo}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                            target.placeholder = "Membership No";
                        }}
                    />
                </div>
                <div class="flex-1 flex items-center">
                    <p class="title">Membership Ref No.:</p>
                    <input
                        type="text"
                        id={`insuranceDetailsMembershipRefNoField-${index}`}
                        placeholder="Membership Ref No"
                        class="input input-sm input-bordered w-remaining"
                        autocomplete="off"
                        bind:value={insuranceDetails.membershipRefNo}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                            target.placeholder = "Membership Ref No";
                        }}
                    />
                </div>
                
            
            {:else if patientDetails.insuranceType == 16}
                <div class="flex-1 flex flex-col gap-4">
                    {#if isLoadingWorkerCompensation}
                        <div class="flex-1 flex items-center gap-x-2">
                            <p>Loading Worker Insurer</p>
                            <Loader />
                        </div>
                    {:else}
                        <div class="flex-1 flex">
                            <p class="title">Insurer:</p>
                            <div class="flex-1 flex rounded-md" id={`workerCompensationContainer-${index}`}>
                                <Select
                                    bind:value={workerCompensation}
                                    id={`workerCompensationSelect-${index}`}
                                    class="flex flex-1 max-h-[35px] rounded-full w-remaining"
                                    items={workerCompensationOptions}
                                    itemId="id"
                                    label="name"
                                    on:clear={clearWorkerCompensation}
                                    on:select={updateWorkcoverInsurerEmail}
                                    noOptionsMessage="No compensation found"
                                    placeholder="Workcover insurer (if known)"
                                    disabled={
                                        !AustralianStates.some(
                                            ({ key }) =>
                                                key ==
                                                patientDetails.insuranceState?.toUpperCase(),
                                        )}
                                    --placeholder-color="#9CA3AF"
                                    --height="32px"
                                    --value-container-padding="0"
                                    --padding="0 0 0 12px"
                                    --font-size="14px"
                                />
                        
                            </div>
                        </div>
                    {/if}

                    {#if workerCompensation?.id}
                        <div class="flex-1 flex">
                            <p class="title">Email:</p>
                            <input
                                type="text"
                                id={`workerCompensationInsurerEmailInput-${index}`}
                                placeholder="Workcover insurer email"
                                class="input w-full input-sm input-bordered w-remaining"
                                autocomplete="off"
                                bind:value={workerCompensationObj.insurerEmail}
                                on:focus={({ target }) => {
                                    target.style.outline = "";
                                    target.placeholder = "Workcover insurer email";
                                }}
                            />
                        </div>
                        {#if !isValidInsurerEmail}
                            <!-- svelte-ignore a11y-label-has-associated-control -->
                            <label class="label">
                                <span class="label-text-alt text-error">
                                    Invalid email
                                </span>
                            </label>
                        {/if}
                    {/if}
                    <div class="flex-1 flex">
                        <p class="title">Claim number:</p>
                        <input
                            type="text"
                            class="input w-full input-sm input-bordered w-remaining"
                            id={`workerCompensationClaimNumberInput-${index}`}
                            autocomplete="off"
                            placeholder="Worker compensation claim number"
                            bind:value={workerCompensationObj.claimNumber}
                            on:focus={({ target }) => {
                                target.style.outline = "";
                                target.placeholder =
                                    "Worker compensation claim number";
                            }}
                        />
                    </div>
                    <div class="flex w-full item-center gap-x-2">
                        <input
                            type="checkbox"
                            id={`skipWorkCoverClaimNoCheckbox-${index}`}
                            class="toggle toggle-secondary"
                            bind:checked={skipWorkCoverClaimNo}
                            on:change={handleSkipWorkCoverClaimNo}
                        />
                        <label
                            for="skipWorkCoverClaimNoCheckbox"
                            class="pt-1 cursor-pointer"
                        >
                            {skipWcAndTacText}
                        </label>
                    </div>
                </div>
                <div class="divider divider-horizontal">OR</div>
                <div class="flex-1 flex flex-col gap-4 items-start">
                    <div class="flex gap-2 w-full items-center">
                        <p class="title">Employer:</p>
                        <input
                            type="text"
                            id={`insuranceDetailsEmployerField-${index}`}
                            placeholder="Employer"
                            class="input w-full input-sm input-bordered w-remaining"
                            autocomplete="off"
                            bind:value={insuranceDetails.employer}
                            on:focus={({ target }) => {
                                target.style.outline = "";
                                target.placeholder = "Employer";
                            }}
                        />
                    </div>
                    <div class="flex gap-2 w-full items-center">
                        <p class="title">Email:</p>
                        <div class="w-remaining flex flex-col">
                            <input
                                type="text"
                                id={`insuranceDetailsEmployerEmailField-${index}`}
                                placeholder="Employer email"
                                class="input w-full input-sm input-bordered"
                                autocomplete="off"
                                bind:value={insuranceDetails.employerEmail}
                                on:focus={({ target }) => {
                                    target.style.outline = "";
                                    target.placeholder = "Employer email";
                                }}
                            />
                            {#if !isValidEmployerEmail}
                                <!-- svelte-ignore a11y-label-has-associated-control -->
                                <label class="label">
                                    <span class="label-text-alt text-error">
                                        Invalid email
                                    </span>
                                </label>
                            {/if}
                        </div>
                    </div>
                </div>
            {:else if patientDetails.insuranceType == 17}
                {#if isLoadingTrafficAuthorities}
                    <div class="flex flex-1 items-center gap-x-2 col-span-full">
                        <p>Loading Traffic Authorities</p>
                        <Loader />
                    </div>
                {:else}
                    <div class="flex flex-1 flex-col gap-2">
                        <div class="flex items-center w-full">
                            <p class="title">Authority:</p>
                            <div class="flex-1 w-remaining {!AustralianStates.some(
                                    ({ key }) =>
                                        key ==
                                        patientDetails.insuranceState?.toUpperCase(),
                                )
                                    ? 'cursor-not-allowed'
                                    : ''}"
                                id={`trafficAuthoritiesContainer-${index}`}
                            >
                                <Select
                                    bind:value={trafficAuthority}
                                    id={`trafficAuthoritySelect-${index}`}
                                    class="flex flex-1 max-h-[35px] rounded-full"
                                    items={trafficAuthorityOptions}
                                    itemId="id"
                                    label="name"
                                    on:clear={clearTrafficAuthority}
                                    on:select={updateTrafficAuthorityEmail}
                                    noOptionsMessage="No authorities found"
                                    placeholder="Traffic Accident Authority"
                                    disabled={
                                        !AustralianStates.some(
                                            ({ key }) =>
                                                key ==
                                                patientDetails.insuranceState?.toUpperCase(),
                                        )}
                                    --placeholder-color="#9CA3AF"
                                    --height="32px"
                                    --value-container-padding="0"
                                    --padding="0 0 0 12px"
                                    --font-size="14px"
                                />
                            </div>
                        </div>

                        {#if trafficAuthority?.id}
                            <div class="flex flex-col gap-y-2">
                                <div class="flex flex-1 items-center">
                                    <p class="title">Authority Email:</p>
                                    <input
                                        type="text"
                                        id={`trafficAuthorityEmailInput-${index}`}
                                        placeholder="Traffic Accident Authority email"
                                        class="input flex-1 input-sm input-bordered w-remaining"
                                        autocomplete="off"
                                        bind:value={trafficAuthorityObj.email}
                                        on:focus={({ target }) => {
                                            target.style.outline = "";
                                            target.placeholder =
                                                "Traffic Accident Authority email";
                                        }}
                                    />
                                </div>
                                {#if !isValidTrafficAuthorityEmail}
                                    <!-- svelte-ignore a11y-label-has-associated-control -->
                                    <label class="label">
                                        <span class="label-text-alt text-error">
                                            Invalid email
                                        </span>
                                    </label>
                                {/if}
                            </div>
                        {/if}
                    </div>

                    <div class="flex flex-1 flex-col gap-2">
                        <div class="flex items-center">
                            <p class="title">Claim No.:</p>
                            <input
                                type="text"
                                class="input flex-1 input-sm input-bordered w-remaining"
                                id={`trafficAuthorityClaimNumberInput-${index}`}
                                autocomplete="off"
                                placeholder="Traffic Accident Authority claim number"
                                bind:value={trafficAuthorityObj.claimNumber}
                                on:focus={({ target }) => {
                                    target.style.outline = "";
                                    target.placeholder =
                                        "Traffic Accident Authority claim number";
                                }}
                            />
                        </div>

                        <div class="flex gap-2 items-center">
                            <input
                                type="checkbox"
                                id={`skipTacClaimNoCheckbox-${index}`}
                                class="toggle toggle-secondary"
                                bind:checked={skipTrafficAuthorityClaimNo}
                                on:change={handleSkipTacClaimNo}
                            />
                            <label
                                for="skipTacClaimNoCheckbox"
                                class="pt-1 cursor-pointer"
                            >
                                {skipWcAndTacText}
                            </label>
                        </div>
                    </div>
                {/if}
            {:else if patientDetails.insuranceType == 18}
                <div class="flex-1 flex flex-col gap-4">
                    <div class="flex gap-2">
                        <div class="flex-1 flex items-center">
                            <p class="title">Payer Name:</p>
                            <input
                                type="text"
                                id={`thirdPartyPayerNameInput-${index}`}
                                placeholder="Payer name (mandatory)"
                                class="input flex-1 input-sm input-bordered w-remaining"
                                autocomplete="off"
                                bind:value={thirdPartyPayerObj.name}
                                on:focus={({ target }) => {
                                    target.style.outline = "";
                                    target.placeholder = "Payer name (mandatory)";
                                }}
                            />
                        </div>

                        <div class="flex-1 flex items-center">
                            <p class="title">Payer Address:</p>
                            <input
                                type="text"
                                id={`thirdPartyPayerAddressInput-${index}`}
                                placeholder="Payer address"
                                class="input flex-1 input-sm input-bordered w-remaining"
                                autocomplete="off"
                                bind:value={thirdPartyPayerObj.address}
                                on:focus={({ target }) => {
                                    target.style.outline = "";
                                    target.placeholder = "Payer address";
                                    errInputs = removeErrorInput(
                                        "thirdPartyPayerEmailInput",
                                        errInputs,
                                        "Payer email",
                                    );
                                }}
                            />
                        </div>
                    </div>
                    <div class="flex gap-2">
                        <div class="flex-1 flex flex-col justify-start">
                            <div class="flex items-center ">
                                <p class="title">Payer Email:</p>
                                <input
                                    type="text"
                                    id={`thirdPartyPayerEmailInput-${index}`}
                                    placeholder="Payer email"
                                    class="input flex-1 input-sm input-bordered w-full"
                                    autocomplete="off"
                                    bind:value={thirdPartyPayerObj.email}
                                    on:focus={({ target }) => {
                                        target.style.outline = "";
                                        target.placeholder = "Payer email";
                                        errInputs = removeErrorInput(
                                            "thirdPartyPayerAddressInput",
                                            errInputs,
                                            "Payer address",
                                        );
                                    }}
                                />
                            
                            </div>
                            {#if !isValidThirdPartyPayerEmail}
                                <div class="flex items-center gap-x-2">
                                    <p class="title" />
                                    <!-- svelte-ignore a11y-label-has-associated-control -->
                                    <label class="label">
                                        <span class="label-text-alt text-error">
                                            Invalid email
                                        </span>
                                    </label>
                                </div>
                            {/if}
                        </div>
                        <div class="flex-1 flex flex-col justify-start">
                            <div class="flex items-center ">
                                <p class="title">Payer Phone No.:</p>
                                <input
                                    type="text"
                                    id={`thirdPartyPayerPhoneNumberInput-${index}`}
                                    placeholder="Payer phone number"
                                    class="input flex-1 input-sm input-bordered w-full"
                                    autocomplete="off"
                                    bind:value={thirdPartyPayerObj.phone}
                                    on:focus={({ target }) => {
                                        target.style.outline = "";
                                        target.placeholder = "Payer phone number";
                                    }}
                                />
                            
                            
                            </div>
                            {#if !isValidThirdPartyPayerPhone}
                                <div class="flex items-center gap-x">
                                    <p class="title" />
                                    <!-- svelte-ignore a11y-label-has-associated-control -->
                                    <label class="label">
                                        <span class="label-text-alt text-error">
                                            Invalid phone
                                        </span>
                                    </label>
                                </div>
                            {/if}
                        </div>
                    </div>
                    <div class="flex gap-2">
                        <div class="flex items-center gap-2">
                            {#if $loggedInDoctorDetail == null || $loggedInDoctorDetail.isRegisteredForGST}
                                <input
                                    type="checkbox"
                                    id={`thirdPartyPayerAddGstCheckbox-${index}`}
                                    class="toggle toggle-secondary"
                                    autocomplete="off"
                                    bind:checked={thirdPartyPayerObj.addGST}
                                />
                                <p class="title">Add GST</p>
                            {/if}
                        </div>
                    </div>
                </div>
                
            {:else if patientDetails.insuranceType == 20}
                <div class="flex-1 flex items-center">
                    <p class="title">Veteran No.:</p>
                    <input
                        type="text"
                        id={`insuranceDetailsDVANumberField-${index}`}
                        placeholder="Veteran number"
                        class="input flex-1 input-sm input-bordered w-remaining"
                        autocomplete="off"
                        bind:value={patientDetails.veteranNo}
                        on:focus={({ target }) => {
                            target.style.outline = "";
                            target.placeholder = "Veteran number";
                        }}
                    />
                </div>
                <div class="flex-1 flex">
                </div>
            {:else if patientDetails.insuranceType == 25 || patientDetails.insuranceType == 26}
                <div class="flex-1 flex flex-col gap-4">
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1 flex items-center">
                            <p class="title">PID:</p>
                            <input
                                type="text"
                                id={`insuranceDetailsPIDField-${index}`}
                                placeholder="PID"
                                class="input flex-1 input-sm input-bordered w-remaining"
                                autocomplete="off"
                                bind:value={defenceObj.pid}
                                on:focus={({ target }) => {
                                    target.style.outline = "";
                                    target.placeholder = "PID";
                                }}
                            />
                        </div>
                        <div class="flex-1 flex items-center">
                            <p class="title">DAN:</p>
                            <input
                                type="text"
                                id={`insuranceDetailsDANField-${index}`}
                                placeholder="DAN"
                                class="input flex-1 input-sm input-bordered w-remaining"
                                autocomplete="off"
                                bind:value={defenceObj.dan}
                                on:focus={({ target }) => {
                                    target.style.outline = "";
                                    target.placeholder = "DAN";
                                }}
                            />
                        </div>
                    </div>
                    <div class="flex flex-1">
                        <div class="flex items-center gap-2">
                            <input
                                type="checkbox"
                                id={`skipDefenceCheckbox-${index}`}
                                class="toggle toggle-secondary"
                                bind:checked={skipDefenceClaimNo}
                                on:change={handleSkipDefenceClaimNo}
                            />
                            <label
                                for="skipDefenceCheckbox"
                                class="pt-1 cursor-pointer"
                            >
                                {skipDefenceText}
                            </label>
                        </div>
                    </div>
                </div>
            
            {:else if patientDetails.insuranceType == 30}
                <div class="flex-1 flex gap-2">
                    <div class="flex-1 flex flex-col gap-1">
                        <div class="flex-1 flex items-center">
                            <p class="title">Email:</p>
                            <input
                                type="text"
                                id={`pipEmailInput-${index}`}
                                placeholder="Email to send invoice"
                                class="input flex-1 input-sm input-bordered w-remaining"
                                autocomplete="off"
                                bind:value={publicInPrivateObj.email}
                                on:focus={({ target }) => {
                                    target.style.outline = "";
                                    target.placeholder = "Email to send invoice";
                                }}
                            />
                        </div>
                        {#if !isValidPipEmail}
                            <div class="flex flex-1 items-center">
                                <p class="title" />
                                <!-- svelte-ignore a11y-label-has-associated-control -->
                                <label class="label">
                                    <span class="label-text-alt text-error">
                                        Invalid email
                                    </span>
                                </label>
                            </div>
                        {/if}
                    </div>
                </div>

                <div class="flex-1 flex items-start">
                    <div class="flex-1 flex items-center">
                        <p class="title">Vendor No.:</p>
                        <input
                            type="text"
                            id={`pipVendorInput-${index}`}
                            placeholder="Vendor number (if applicable)"
                            class="input flex-1 input-sm input-bordered w-remaining"
                            autocomplete="off"
                            bind:value={publicInPrivateObj.vendorNumbers}
                            on:focus={({ target }) => {
                                target.style.outline = "";
                                target.placeholder =
                                    "Vendor number (if applicable)";
                            }}
                        />
                    </div>
                </div>
            {/if}
        </div>
    {/if}
</div>

<OpvStatusModal
    {opvResult}
    isModalOpen={opvResultModalOpen}
    closeModal={_closeOpvResultModal}
/>

<style>
    .title {
        width: 160px;
    }

    .w-remaining {
        width: calc(100% - 160px);
    }
</style>
